module.exports = __webpack_public_path__ + "static/img/login_logo_blue.d58e7d42.png";